var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 11.25H12L6 0.75L0 11.25ZM6.54545 9.5921H5.45455V8.48684H6.54545V9.5921ZM6.54545 7.38158H5.45455V5.17105H6.54545V7.38158Z",
  fill: "white"
})));
export { SvgWarning as ReactComponent };
export default __webpack_public_path__ + "507afbfd55fd6951b7a2c5a7fea8dd6e.svg";